import Immutable from 'immutable';

export default Immutable.fromJS({
  errors        : [],
  isActive      : false,
  lastAddedName : null,
  loaded        : {
    all  : [],
    show : {},
  },
});
